"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8565],{

/***/ 75176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ AnalyticsConstants; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_object_freeze_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43371);
/* harmony import */ var core_js_modules_es_object_freeze_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_freeze_js__WEBPACK_IMPORTED_MODULE_0__);

var AnalyticsConstants = Object.freeze({
  collapseText: 'Collapse Link',
  expandText: 'Expand Link',
  learnMoreText: 'Learn More',
  countrySelectorText: 'Open Country Selector Panel',
  openVideoText: 'Open Video',
  buttonPriceText: 'Open Price Panel',
  contentVideoOverlayText: 'Outside Panel',
  videoPlayText: 'Play',
  videoPauseText: 'Pause',
  videoMuteText: 'Sound: Off',
  videoUnmuteText: 'Sound: On',
  videoCloseCaptionsOnText: 'Caption: On',
  videoCloseCaptionsOffText: 'Caption: Off',
  videoFullscreenOnText: 'Full Screen: On',
  videoFullscreenOffText: 'Full Screen: Off',
  dropdownMenu: 'Dropdown Menu',
  rotationView: '360 View',
  facebook: 'Facebook',
  twitter: 'Twitter',
  openLiveChat: 'Open Live Chat',
  expandFaq: 'Expand FAQ',
  previousPage: 'Previous Page',
  nextPage: 'Next Page',
  promoRedeem: 'Redeem: ',
  calender: 'Calender'
});

/***/ }),

/***/ 71357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LI": function() { return /* binding */ useIsomorphicLayoutEffect; },
/* harmony export */   "Ui": function() { return /* binding */ mediaQueryHOC; },
/* harmony export */   "ag": function() { return /* binding */ useMatchMedia; },
/* harmony export */   "hZ": function() { return /* binding */ useScrollBlock; },
/* harmony export */   "y3": function() { return /* binding */ updateCurrentProductIndex; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47941);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57327);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38880);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49337);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33321);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69070);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(930);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(89554);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_parse_int_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(91058);
/* harmony import */ var core_js_modules_es_parse_int_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_parse_int_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(19601);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(85893);














function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_8___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

 // https://github.com/streamich/react-use/blob/master/docs/useIsomorphicLayoutEffect.md


var useIsomorphicLayoutEffect =  true ? react__WEBPACK_IMPORTED_MODULE_13__.useLayoutEffect : 0;
function useMatchMedia(mediaQueryString) {
  var initialValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_13__.useState)(initialValue),
      match = _useState[0],
      setMatch = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_13__.useEffect)(function () {
    if (!window.matchMedia) {
      return;
    }

    function handleMatch(event) {
      setMatch(event.matches);
    }

    var matchMedia = window.matchMedia(mediaQueryString);
    setMatch(matchMedia.matches);
    matchMedia.addListener(handleMatch);
    return function () {
      matchMedia.removeListener(handleMatch);
    };
  }, [mediaQueryString]);
  return match;
}
var mediaQueryHOC = function mediaQueryHOC(Component) {
  function MediaQueryHOC(props) {
    var isXSmall = useMatchMedia('(max-width: 375px)');
    var isSmall = useMatchMedia('(max-width: 479px)');
    var isMedium = useMatchMedia('(max-width: 767px)');
    var isLarge = useMatchMedia('(max-width: 991px)');
    var isXLarge = useMatchMedia('(max-width: 1023px)');
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(Component, _objectSpread({
      isXSmall: isXSmall,
      isSmall: isSmall,
      isMedium: isMedium,
      isLarge: isLarge,
      isXLarge: isXLarge
    }, props));
  }

  return MediaQueryHOC;
};
var listeners = [];
var state = {
  currentProductIndex: 0
};

var setState = function setState(newState) {
  state = _objectSpread(_objectSpread({}, state), newState);
  listeners.forEach(function (listener) {
    listener(state);
  });
};

var updateCurrentProductIndex = function updateCurrentProductIndex() {
  var newListener = (0,react__WEBPACK_IMPORTED_MODULE_13__.useState)()[1];
  (0,react__WEBPACK_IMPORTED_MODULE_13__.useEffect)(function () {
    listeners.push(newListener);
  }, []);
  return [state, setState];
};
var useScrollBlock = function useScrollBlock() {
  var scroll = (0,react__WEBPACK_IMPORTED_MODULE_13__.useRef)(false);

  var blockScroll = function blockScroll() {
    if (typeof document === "undefined") return;
    var html = document.documentElement;
    var _document = document,
        body = _document.body;
    if (!(body == null ? void 0 : body.style) || scroll.current) return;
    var scrollBarWidth = window.innerWidth - html.clientWidth;
    var bodyPaddingRight = parseInt(window.getComputedStyle(body).getPropertyValue("padding-right")) || 0;
    Object.assign(html.style, {
      position: "relative",
      overflow: "hidden"
    });
    Object.assign(body.style, {
      position: "relative",
      overflow: "hidden",
      paddingRight: "".concat(bodyPaddingRight + scrollBarWidth, "px")
    });
    scroll.current = true;
  };

  var allowScroll = function allowScroll() {
    if (typeof document === "undefined") return;
    var html = document.documentElement;
    var _document2 = document,
        body = _document2.body;
    if (!(body == null ? void 0 : body.style) || !scroll.current) return;
    Object.assign(html.style, {
      position: "",
      overflow: ""
    });
    Object.assign(body.style, {
      position: "",
      overflow: "",
      paddingRight: ""
    });
    scroll.current = false;
  };

  return [blockScroll, allowScroll];
};

/***/ }),

/***/ 44291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Label": function() { return /* binding */ Label; },
/* harmony export */   "LabelHTML": function() { return /* binding */ LabelHTML; },
/* harmony export */   "replaceTokensFromString": function() { return /* binding */ replaceTokensFromString; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47941);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57327);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38880);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89554);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(49337);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(33321);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69070);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(930);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3323);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(74916);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(15306);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_regexp_constructor_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(24603);
/* harmony import */ var core_js_modules_es_regexp_constructor_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_constructor_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_regexp_sticky_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(88386);
/* harmony import */ var core_js_modules_es_regexp_sticky_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_sticky_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(39714);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(67294);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(29238);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(85893);












var _excluded = ["label", "tokens"];






function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_10___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





/* harmony default export */ __webpack_exports__["default"] = (Label);
function Label(_ref) {
  var label = _ref.label,
      tokens = _ref.tokens;

  if (!label) {
    return '';
  } else if (tokens) {
    var _label$fields;

    return replaceTokensFromString((label == null ? void 0 : (_label$fields = label.fields) == null ? void 0 : _label$fields.text) || label, tokens);
  } else {
    var _label$fields2;

    return (label == null ? void 0 : (_label$fields2 = label.fields) == null ? void 0 : _label$fields2.text) || label;
  }
}
Label.propTypes = {
  label: prop_types__WEBPACK_IMPORTED_MODULE_17___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_17___default().string), (prop_types__WEBPACK_IMPORTED_MODULE_17___default().object)]),
  tokens: (prop_types__WEBPACK_IMPORTED_MODULE_17___default().object)
};
function LabelHTML(_ref2) {
  var label = _ref2.label,
      tokens = _ref2.tokens,
      props = _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_11___default()(_ref2, _excluded);

  if (!label) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("span", _objectSpread({}, props));
  } else if (tokens) {
    var _label$fields3;

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("span", _objectSpread({
      dangerouslySetInnerHTML: {
        __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_19___default().sanitize(replaceTokensFromString((label == null ? void 0 : (_label$fields3 = label.fields) == null ? void 0 : _label$fields3.text) || label, tokens))
      }
    }, props));
  } else {
    var _label$fields4;

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("span", _objectSpread({
      dangerouslySetInnerHTML: {
        __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_19___default().sanitize((label == null ? void 0 : (_label$fields4 = label.fields) == null ? void 0 : _label$fields4.text) || label)
      }
    }, props));
  }
}
function replaceTokensFromString(s, tokens) {
  for (var tokenKey in tokens) {
    s = s.replace(new RegExp('{' + tokenKey + '}', 'g'), tokens[tokenKey]);
  }

  return s;
}

/***/ }),

/***/ 88565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LanguageSelectionTest": function() { return /* binding */ LanguageSelectionTest; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88674);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92222);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21249);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68309);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_link_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29254);
/* harmony import */ var core_js_modules_es_string_link_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_link_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_slide_toggle__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5021);
/* harmony import */ var react_slide_toggle__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react_slide_toggle__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _adapters_helpers_Block__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(40483);
/* harmony import */ var _adapters_helpers_Anchor__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(97020);
/* harmony import */ var _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(24036);
/* harmony import */ var _adapters_helpers_ConstantsGA__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(75176);
/* harmony import */ var _adapters_helpers_Utils__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(8996);
/* harmony import */ var _Label_Label__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(44291);
/* harmony import */ var _adapters_helpers_Hooks__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(71357);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(85893);


















var Icon = next_dynamic__WEBPACK_IMPORTED_MODULE_7___default()(function () {
  return __webpack_require__.e(/* import() */ 713).then(__webpack_require__.bind(__webpack_require__, 80713));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(80713)];
    }
  }
});
var primaryColor = _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_11__/* .LanguageSelectionConstants.primaryColor */ .$G.primaryColor;

function LanguageSelection(props) {
  var block = new _adapters_helpers_Block__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z(props);
  var anchor = (0,_adapters_helpers_Anchor__WEBPACK_IMPORTED_MODULE_10__/* .useAnchor */ .Wb)();
  var overlayToggleRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)();
  var languageSelectorRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)();
  var linksRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false),
      isLanguageSelectorOpen = _useState[0],
      setLanguageSelectorOpen = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(0),
      lastScroll = _useState2[0],
      setLastScroll = _useState2[1];

  var handleExpanding = (0,react__WEBPACK_IMPORTED_MODULE_6__.useCallback)(function () {
    setLanguageSelectorOpen(true);
  }, []);
  var handleCollapsing = (0,react__WEBPACK_IMPORTED_MODULE_6__.useCallback)(function () {
    setLanguageSelectorOpen(false);
  }, []);
  var handleClickOutside = (0,react__WEBPACK_IMPORTED_MODULE_6__.useCallback)(function (event) {
    if (overlayToggleRef.current && languageSelectorRef.current && !languageSelectorRef.current.contains(event.target)) {
      overlayToggleRef.current.onToggle();
    }
  }, []);

  var trapFocusInOverlay = function trapFocusInOverlay(event) {
    if (!isLanguageSelectorOpen) {
      return;
    }

    var element = event.currentTarget;
    var focusableElements = element.querySelectorAll('button:not([disabled]), a[href]:not([disabled])');
    var firstFocusableElement = focusableElements == null ? void 0 : focusableElements[0];
    var lastFocusableElement = focusableElements[focusableElements.length - 1];
    var KEYCODE_TAB = 9;
    element.addEventListener('keydown', function (e) {
      var isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;

      if (!isTabPressed) {
        return;
      }

      if (e.shiftKey)
        /* shift + tab */
        {
          if (document.activeElement === firstFocusableElement) {
            lastFocusableElement.focus();
            e.preventDefault();
          }
        } else
        /* tab */
        {
          if (document.activeElement === lastFocusableElement) {
            firstFocusableElement.focus();
            e.preventDefault();
          }
        }
    });
  };

  var handleScroll = (0,react__WEBPACK_IMPORTED_MODULE_6__.useCallback)(function () {
    if (!document.body.classList.contains('noScroll')) {
      setLastScroll(window.pageYOffset);
    }
  });
  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    if (isLanguageSelectorOpen) {
      window.addEventListener('mousedown', handleClickOutside);
      (0,_adapters_helpers_Utils__WEBPACK_IMPORTED_MODULE_13__/* .toggleScroll */ .a9)(isLanguageSelectorOpen, lastScroll);
      return function () {
        window.removeEventListener('mousedown', handleClickOutside);
      };
    } else {
      (0,_adapters_helpers_Utils__WEBPACK_IMPORTED_MODULE_13__/* .toggleScroll */ .a9)(isLanguageSelectorOpen, lastScroll);
    }
  }, [isLanguageSelectorOpen]);
  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    window.addEventListener('scroll', handleScroll);
    return function () {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScroll]);
  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    if (languageSelectorRef == null ? void 0 : languageSelectorRef.current) {
      languageSelectorRef.current.addEventListener(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_11__/* .LanguageSelectionConstants.keydown */ .$G.keydown, trapFocusInOverlay);
      return function () {
        var _languageSelectorRef$;

        (_languageSelectorRef$ = languageSelectorRef.current) == null ? void 0 : _languageSelectorRef$.removeEventListener(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_11__/* .LanguageSelectionConstants.keydown */ .$G.keydown, trapFocusInOverlay);
      };
    }
  }, [isLanguageSelectorOpen]);

  var scrollTo = function scrollTo(event) {
    event.preventDefault();

    if (languageSelectorRef.current) {
      var currentTarget = event.currentTarget;
      var anchorId = currentTarget.dataset.anchorId;
      var element = languageSelectorRef.current.querySelector("[data-id=".concat(anchorId, "]"));
      element.scrollIntoView({
        behavior: _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_11__/* .LanguageSelectionConstants.smooth */ .$G.smooth
      });
    }
  };

  var calculateHeight = function calculateHeight() {
    var announcementBar = document.querySelector('.ob-announcement-bar');
    var overlay = languageSelectorRef.current.querySelector('.ob-language-overlay');
    var header = document.querySelector('.zone-header');

    if (props.isMedium) {
      if (announcementBar && announcementBar.style.display !== 'none') {
        linksRef.current.style.height = "calc(".concat(window.innerHeight, "px - ").concat(linksRef.current.offsetTop + announcementBar.offsetHeight, "px)");
        overlay.style.height = "calc(".concat(window.innerHeight, "px - ").concat(overlay.offsetTop + announcementBar.offsetHeight, "px)");
      } else {
        linksRef.current.style.height = "calc(".concat(window.innerHeight, "px - ").concat(linksRef.current.offsetTop, "px)");
        overlay.style.height = "calc(".concat(window.innerHeight, "px - ").concat(overlay.offsetTop, "px)");
      }
    } else {
      if (header) {
        overlay.style.height = "calc(".concat(window.innerHeight, "px - ").concat(overlay.offsetTop, "px)");
        linksRef.current.style.height = "".concat(window.innerHeight - (linksRef.current.offsetTop + header.offsetHeight), "px");
      }
    }
  }; // This is the label displayed and also serves as the CTA to trigger the language menu


  var currentLanguage = block.getFieldValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_11__/* .LanguageSelectionConstants.currentLanguage */ .$G.currentLanguage);
  var title = block.getFieldValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_11__/* .LanguageSelectionConstants.title */ .$G.title);
  var regions = block.getFieldValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_11__/* .LanguageSelectionConstants.regions */ .$G.regions);
  var jumpToCopy = (0,_Label_Label__WEBPACK_IMPORTED_MODULE_14__.Label)({
    label: block.getFieldValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_11__/* .LanguageSelectionConstants.jumpToLabel */ .$G.jumpToLabel)
  });
  var closeButtonCopy = (0,_Label_Label__WEBPACK_IMPORTED_MODULE_14__.Label)({
    label: block.getFieldValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_11__/* .LanguageSelectionConstants.closeLanguageSelectionLabel */ .$G.closeLanguageSelectionLabel)
  });
  var LanguageSelectionAriaLabel = block.getFieldValue(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_11__/* .LanguageSelectionConstants.countryLanguageAriaLabel */ .$G.countryLanguageAriaLabel);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)((react_slide_toggle__WEBPACK_IMPORTED_MODULE_8___default()), {
    ref: overlayToggleRef,
    duration: 500,
    collapsed: true,
    onExpanding: handleExpanding,
    onCollapsing: handleCollapsing,
    onExpanded: calculateHeight,
    children: function children(_ref) {
      var onToggle = _ref.onToggle,
          setCollapsibleElement = _ref.setCollapsibleElement,
          toggleState = _ref.toggleState;
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)("div", {
        className: "ob-language-selector",
        ref: languageSelectorRef,
        onKeyDown: function onKeyDown(event) {
          if (event.key === _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_11__/* .MainMenuConstants.capEscape */ .o5.capEscape && (toggleState === _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_11__/* .MainMenuConstants.capExpanded */ .o5.capExpanded || toggleState === _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_11__/* .MainMenuConstants.capExpanding */ .o5.capExpanding)) {
            onToggle();
          }
        },
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)("button", {
          className: "event_button_click ob-language-selector-toggle",
          "aria-label": LanguageSelectionAriaLabel,
          "data-action-detail": _adapters_helpers_ConstantsGA__WEBPACK_IMPORTED_MODULE_12__/* .AnalyticsConstants.countrySelectorText */ .k.countrySelectorText,
          onClick: function onClick() {
            onToggle();
            calculateHeight();
          },
          children: [currentLanguage, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(Icon, {
            className: "ob-language-selector-toggle-icon",
            name: _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_11__/* .LanguageSelectionConstants.wideChevronDown */ .$G.wideChevronDown,
            size: "0.8"
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("div", {
          className: "language-overlay ob-language-overlay",
          ref: setCollapsibleElement,
          style: {
            display: 'none'
          },
          role: _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_11__/* .MainMenuConstants.menuitem */ .o5.menuitem,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)("div", {
            className: "ob-language-overlay-inner",
            role: _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_11__/* .MainMenuConstants.menubar */ .o5.menubar,
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("div", {
              className: "ob-language-overlay-header",
              role: _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_11__/* .MainMenuConstants.menuitem */ .o5.menuitem,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("h2", {
                className: "ob-language-overlay-title",
                children: title
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("div", {
              role: _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_11__/* .MainMenuConstants.menubar */ .o5.menubar,
              className: "ob-language-overlay-tabs",
              "aria-label": _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_11__/* .MainMenuConstants.menulist */ .o5.menulist,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("div", {
                role: _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_11__/* .MainMenuConstants.menuitem */ .o5.menuitem,
                className: "ob-language-overlay-tabs-desktop",
                "aria-label": _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_11__/* .MainMenuConstants.menulistDesktop */ .o5.menulistDesktop,
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("ul", {
                  className: "mini-nav-regions ob-language-overlay-tabs",
                  children: regions.map(function (region, index) {
                    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("li", {
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("a", {
                        "aria-label": region.fields.name,
                        className: "event_internal_link",
                        "data-action-detail": (0,_adapters_helpers_Anchor__WEBPACK_IMPORTED_MODULE_10__/* .getAnchorIdFromEntity */ .BO)(region),
                        href: "#".concat((0,_adapters_helpers_Anchor__WEBPACK_IMPORTED_MODULE_10__/* .getAnchorIdFromEntity */ .BO)(region), "-").concat(index),
                        "data-anchor-id": (0,_adapters_helpers_Anchor__WEBPACK_IMPORTED_MODULE_10__/* .getAnchorIdFromEntity */ .BO)(region),
                        onClick: scrollTo,
                        children: region.fields.name
                      })
                    }, "region-nav-".concat(index));
                  })
                })
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)("div", {
              role: _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_11__/* .MainMenuConstants.menubar */ .o5.menubar,
              "aria-label": _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_11__/* .MainMenuConstants.languageLink */ .o5.languageLink,
              className: "ob-language-overlay-links",
              ref: linksRef,
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("div", {
                role: _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_11__/* .MainMenuConstants.menuitem */ .o5.menuitem,
                "aria-label": _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_11__/* .MainMenuConstants.languageLink */ .o5.languageLink,
                className: "ob-language-overlay-tabs",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)((react_slide_toggle__WEBPACK_IMPORTED_MODULE_8___default()), {
                  duration: 500,
                  collapsed: true,
                  children: function children(_ref2) {
                    var onToggle = _ref2.onToggle,
                        setCollapsibleElement = _ref2.setCollapsibleElement,
                        toggleState = _ref2.toggleState;
                    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)("div", {
                      "aria-label": _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_11__/* .MainMenuConstants.languageTabMobile */ .o5.languageTabMobile,
                      className: "ob-language-overlay-tabs-mobile",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)("button", {
                        "aria-expanded": toggleState === _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_11__/* .MainMenuConstants.capExpanded */ .o5.capExpanded || toggleState === _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_11__/* .MainMenuConstants.capExpanding */ .o5.capExpanding ? true : false,
                        className: "ob-language-overlay-tabs-toggle",
                        "aria-label": _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_11__/* .MainMenuConstants.expandingMenu */ .o5.expandingMenu,
                        onClick: onToggle,
                        children: [jumpToCopy, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("span", {
                          className: "ob-language-overlay-tabs-toggle--icon",
                          children: toggleState === _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_11__/* .MainMenuConstants.capExpanded */ .o5.capExpanded || toggleState === _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_11__/* .MainMenuConstants.capExpanding */ .o5.capExpanding ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(Icon, {
                            name: _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_11__/* .MainMenuConstants.chevronTop */ .o5.chevronTop,
                            color: _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_11__/* .MainMenuConstants.white */ .o5.white,
                            size: 2
                          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(Icon, {
                            name: _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_11__/* .MainMenuConstants.chevronDown */ .o5.chevronDown,
                            color: _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_11__/* .MainMenuConstants.white */ .o5.white,
                            size: 2
                          })
                        })]
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("div", {
                        ref: setCollapsibleElement,
                        role: _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_11__/* .MainMenuConstants.menuitem */ .o5.menuitem,
                        className: "ob-language-overlay-tabs-mobile-inner",
                        style: {
                          display: 'none'
                        },
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("ul", {
                          className: "mini-nav-regions",
                          children: regions.map(function (region, index) {
                            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("li", {
                              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("h3", {
                                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("a", {
                                  "aria-label": region.fields.name,
                                  className: "event_internal_link",
                                  "data-action-detail": (0,_adapters_helpers_Anchor__WEBPACK_IMPORTED_MODULE_10__/* .getAnchorIdFromEntity */ .BO)(region),
                                  href: "#".concat((0,_adapters_helpers_Anchor__WEBPACK_IMPORTED_MODULE_10__/* .getAnchorIdFromEntity */ .BO)(region), "-").concat(index),
                                  "data-anchor-id": (0,_adapters_helpers_Anchor__WEBPACK_IMPORTED_MODULE_10__/* .getAnchorIdFromEntity */ .BO)(region),
                                  onClick: scrollTo,
                                  children: region.fields.name
                                })
                              })
                            }, 'region-nav-' + index);
                          })
                        })
                      })]
                    });
                  }
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("ul", {
                className: "market-selection",
                children: regions.map(function (region, regionIndex) {
                  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)("li", {
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("h2", {
                      className: "market-selection-title",
                      "data-id": (0,_adapters_helpers_Anchor__WEBPACK_IMPORTED_MODULE_10__/* .getAnchorIdFromEntity */ .BO)(region),
                      id: "".concat((0,_adapters_helpers_Anchor__WEBPACK_IMPORTED_MODULE_10__/* .getAnchorIdFromEntity */ .BO)(region), "-").concat(regionIndex),
                      children: region.fields.name
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("ul", {
                      children: region.fields.markets.map(function (market, marketIndex) {
                        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("li", {
                          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("a", {
                            "aria-label": market.fields.nativeLanguageLabel,
                            className: "event_internal_link",
                            "data-action-detail": market.fields.nativeLanguageLabel,
                            href: market.fields.link,
                            lang: market.fields.languageCode,
                            children: market.fields.nativeLanguageLabel
                          })
                        }, 'market-' + marketIndex);
                      })
                    })]
                  }, 'region-' + regionIndex);
                })
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("button", {
              className: "event_close_window ob-language-overlay-close-btn",
              onClick: onToggle,
              "aria-label": closeButtonCopy,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(Icon, {
                name: _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_11__/* .LanguageSelectionConstants.close */ .$G.close,
                size: "2.4",
                color: primaryColor,
                arialable: closeButtonCopy
              })
            })]
          })
        })]
      });
    }
  });
}

/* harmony default export */ __webpack_exports__["default"] = ((0,_adapters_helpers_Hooks__WEBPACK_IMPORTED_MODULE_15__/* .mediaQueryHOC */ .Ui)(LanguageSelection)); // This export is for unit testing (do not remove) :

var LanguageSelectionTest = LanguageSelection;

/***/ })

}]);